import { Dictionary } from "../../../../../../../../react-core/Helpers/CommonHelper";
import { PaymentSource } from "../../../../../../../../Wrap/Constants/Enums/Domain/PaymentSource";
import { InvestmentTransactionTypes } from "../../../../../../../../Wrap/Constants/Enums/Transactions/InvestmentTransactionTypes";
import { CashTransactionTypes } from "../../../../../../../../Wrap/Models/Domains/Transactions/Cash/CashTransactionTypes";
import { ChargesQueryType } from "../../../../../../../../Wrap/Models/Domains/Transactions/Charges/ChargesQueryType";
import { PaymentStatus } from "../../../../../../../../Wrap/Models/Models/PortfolioAnalysis/Investment/PaymentStatus";
import { CashPaymentFrequencyQuery } from "../../../../../../../../Wrap/Models/Models/PortfolioAnalysis/Payment/CashPaymentFrequencyQuery";
import { CashPaymentTypeQuery } from "../../../../../../../../Wrap/Models/Models/PortfolioAnalysis/Payment/CashPaymentTypeQuery";

export const cashPaymentTypeArray = [
    CashPaymentTypeQuery.All,
    CashPaymentTypeQuery.Deposit,
    CashPaymentTypeQuery.Withdrawal,
    CashPaymentTypeQuery.RegularPercentage,
    CashPaymentTypeQuery.RegularAmount,
];
export enum TransactionEnum {
    summary = "Summary",
    cash = "Cash",
    investments = "Investments",
    paymentsWithdrawals = "Payments / withdrawals",
    accountTransfers = "Account transfers",
    corporateActions = "Dividend summary",
    otherCorporateActions = "Other corporate actions",
    charges = "Charges",
    offPlatformIncome = "Off platform Income"
}
export const TransactionEnumArray = [
    TransactionEnum.summary,
    TransactionEnum.cash,
    TransactionEnum.investments,
    TransactionEnum.paymentsWithdrawals,
    TransactionEnum.accountTransfers,
    TransactionEnum.corporateActions,
    TransactionEnum.otherCorporateActions,
    TransactionEnum.charges,
    TransactionEnum.offPlatformIncome
];

export const cashPaymentTypeMap = {
    [CashPaymentTypeQuery.All]: "All",
    [CashPaymentTypeQuery.Deposit]: "Deposit",
    [CashPaymentTypeQuery.Withdrawal]: "Withdrawal",
    [CashPaymentTypeQuery.RegularPercentage]: "Regular Percentage",
    [CashPaymentTypeQuery.RegularAmount]: "Regular Amount",
};
export const cashPaymentFrequencyArray = [
    CashPaymentFrequencyQuery.All,
    CashPaymentFrequencyQuery.Single,
    CashPaymentFrequencyQuery.Regular,
    CashPaymentFrequencyQuery.Auto,
];
export const cashPaymentFrequencyMap = {
    [CashPaymentFrequencyQuery.All]: "All",
    [CashPaymentFrequencyQuery.Single]: "Single",
    [CashPaymentFrequencyQuery.Regular]: "Regular",
    [CashPaymentFrequencyQuery.Auto]: "Auto",
};

export const chargesQueryTypeArray = [
    ChargesQueryType.All,
    ChargesQueryType.StandardLife,
    ChargesQueryType.Adviser,
    ChargesQueryType.Dim,
    ChargesQueryType.Investment,
];

export const chargesQueryTypeMap = {
    [ChargesQueryType.All]: "All charges",
    [ChargesQueryType.Adviser]: "Adviser charges",
    [ChargesQueryType.Dim]: " Portfolio manager fees",
    [ChargesQueryType.Investment]: "Investment charges",
    [ChargesQueryType.StandardLife]: "Platform charges",
};

export enum SortNameEnum {
    ExDate = "ExDate",
    PostDate = "PostDate",
    AsAt = "AsAt",
    UnitCost = "Cost",
    TotalCost = "TotalCost",
    DividendPayDate = "DividendPayDate",
}

export const ModelTypeOptions: Dictionary[] = [
    { key: InvestmentTransactionTypes.NotSpecified + "", value: "All" },
    { key: InvestmentTransactionTypes.BuyTrade + "", value: "Buy Trade" },
    { key: InvestmentTransactionTypes.CNoteInstruction + "", value: "Contract Note Instruction" },
    { key: InvestmentTransactionTypes.ConversionIn + "", value: "Conversion In" },
    { key: InvestmentTransactionTypes.ConversionOut + "", value: "Conversion Out" },
    { key: InvestmentTransactionTypes.CorporateAction + "", value: "Corporate Action" },
    { key: InvestmentTransactionTypes.ErrorBooking + "", value: "Error Booking" },
    { key: InvestmentTransactionTypes.FundApplication + "", value: "Fund Application" },
    { key: InvestmentTransactionTypes.FundRedemption + "", value: "Fund Redemption" },
    { key: InvestmentTransactionTypes.Grp2toGrp1 + "", value: "Grp 2 to Grp1" },
    { key: InvestmentTransactionTypes.LocationTransfer + "", value: "Location Transfer" },
    { key: InvestmentTransactionTypes.ManualTrans + "", value: "Manual Transaction" },
    { key: InvestmentTransactionTypes.SellTrade + "", value: "Sell Trade" },
    { key: InvestmentTransactionTypes.TransferIn + "", value: "Transfer In" },
    { key: InvestmentTransactionTypes.TransferOut + "", value: "Transfer Out" },
    { key: InvestmentTransactionTypes.Other + "", value: "Other" },
];

export const UnModelTypeOptions: Dictionary[] = [
    { key: InvestmentTransactionTypes.NotSpecified + "", value: "All" },
    { key: InvestmentTransactionTypes.AccountTransfer + "", value: "Account Transfer" },
    { key: InvestmentTransactionTypes.AutoDisinvestment + "", value: "Auto Disinvestment" },
    { key: InvestmentTransactionTypes.BuyTrade + "", value: "Buy Trade" },
    { key: InvestmentTransactionTypes.CNoteInstruction + "", value: "Contract Note Instruction" },
    { key: InvestmentTransactionTypes.ConversionIn + "", value: "Conversion In" },
    { key: InvestmentTransactionTypes.ConversionOut + "", value: "Conversion Out" },
    { key: InvestmentTransactionTypes.CorporateAction + "", value: "Corporate Action" },
    { key: InvestmentTransactionTypes.ErrorBooking + "", value: "Error Booking" },
    { key: InvestmentTransactionTypes.FundApplication + "", value: "Fund Application" },
    { key: InvestmentTransactionTypes.FundRedemption + "", value: "Fund Redemption" },
    { key: InvestmentTransactionTypes.Grp2toGrp1 + "", value: "Grp 2 to Grp1" },
    { key: InvestmentTransactionTypes.LocationTransfer + "", value: "Location Transfer" },
    { key: InvestmentTransactionTypes.ManualTrans + "", value: "Manual Transaction" },
    { key: InvestmentTransactionTypes.SecurityTransfer + "", value: "Security Transfer" },
    { key: InvestmentTransactionTypes.SellTrade + "", value: "Sell Trade" },
    { key: InvestmentTransactionTypes.Settled + "", value: "Settled" },
    { key: InvestmentTransactionTypes.StdLife + "", value: "Standard Life" },
    { key: InvestmentTransactionTypes.TransferIn + "", value: "Transfer In" },
    { key: InvestmentTransactionTypes.TransferOut + "", value: "Transfer Out" },
    { key: InvestmentTransactionTypes.TrialBuyTrade + "", value: "Trial Buy Trade" },
    { key: InvestmentTransactionTypes.TrialSellTrade + "", value: "Trial Sell Trade" },
    { key: InvestmentTransactionTypes.Other + "", value: "Other" },
];

export const InvestmentTransactionTypeMap = {
    [InvestmentTransactionTypes.NotSpecified]: "Not Specified",
    [InvestmentTransactionTypes.AccountTransfer]: "Account Transfer",
    [InvestmentTransactionTypes.BuyTrade]: "Buy Trade",
    [InvestmentTransactionTypes.CNoteInstruction]: "Contract Note Instruction",
    [InvestmentTransactionTypes.ConversionIn]: "Conversion In",
    [InvestmentTransactionTypes.ConversionOut]: "Conversion Out",
    [InvestmentTransactionTypes.CorporateAction]: "Corporate Action",
    [InvestmentTransactionTypes.ErrorBooking]: "Error Booking",
    [InvestmentTransactionTypes.FundApplication]: "Fund Application",
    [InvestmentTransactionTypes.FundRedemption]: "Fund Redemption",
    [InvestmentTransactionTypes.Grp2toGrp1]: "Grp 2 to Grp1",
    [InvestmentTransactionTypes.LocationTransfer]: "Location Transfer",
    [InvestmentTransactionTypes.ManualTrans]: "Manual Transaction",
    [InvestmentTransactionTypes.SecurityTransfer]: "Security Transfer",
    [InvestmentTransactionTypes.SellTrade]: "Sell Trade",
    [InvestmentTransactionTypes.Settled]: "Settled",
    [InvestmentTransactionTypes.StdLife]: "Standard Life",
    [InvestmentTransactionTypes.TransferIn]: "Transfer In",
    [InvestmentTransactionTypes.TransferOut]: "Transfer Out",
    [InvestmentTransactionTypes.TrialBuyTrade]: "Trial Buy Trade",
    [InvestmentTransactionTypes.TrialSellTrade]: "Trial Sell Trade",
    [InvestmentTransactionTypes.AutoDisinvestment]: "Auto Disinvestment",
    [InvestmentTransactionTypes.SwitchIn]: "Switch In",
    [InvestmentTransactionTypes.SwitchOut]: "Switch Out",
    [InvestmentTransactionTypes.Other]: "Other",
};

export const CashModelTypeOptions: Dictionary[] = [
    { key: CashTransactionTypes.Unknown + "", value: "All" },
    { key: CashTransactionTypes.BuyTrade + "", value: "Buy Trade" },
    { key: CashTransactionTypes.CapitalIn + "", value: "Capital In" },
    { key: CashTransactionTypes.CapitalOut + "", value: "Capital Out" },
    { key: CashTransactionTypes.Compensation + "", value: "Compensation" },
    { key: CashTransactionTypes.Deposit + "", value: "Deposit" },
    { key: CashTransactionTypes.FundApplication + "", value: "Fund Application" },
    { key: CashTransactionTypes.Fee + "", value: "Fee" },
    { key: CashTransactionTypes.FundRedemption + "", value: "Fund Redemption" },
    { key: CashTransactionTypes.GrossDividend + "", value: "Gross Dividend" },
    { key: CashTransactionTypes.ProductTransfer + "", value: "Product Transfer" },
    { key: CashTransactionTypes.ReturnofCapital + "", value: "Return of Capital" },
    { key: CashTransactionTypes.SellTrade + "", value: "Sell Trade" },
    { key: CashTransactionTypes.WithholdingTax + "", value: "Withholding Tax" },
    { key: CashTransactionTypes.Withdrawal + "", value: "Withdrawal" },
    { key: CashTransactionTypes.Other + "", value: "Other" },
];

export const CashUnModelTypeOptions: Dictionary[] = [
    { key: CashTransactionTypes.Unknown + "", value: "All" },
    { key: CashTransactionTypes.BuyTrade + "", value: "Buy Trade" },
    { key: CashTransactionTypes.CallTransaction + "", value: "Call Transaction" },
    { key: CashTransactionTypes.CapitalIn + "", value: "Capital In" },
    { key: CashTransactionTypes.CapitalOut + "", value: "Capital Out" },
    { key: CashTransactionTypes.CMTInterest + "", value: "CMT Interest" },
    { key: CashTransactionTypes.Compensation + "", value: "Compensation" },
    { key: CashTransactionTypes.CorporateAction + "", value: "Corporate Action" },
    { key: CashTransactionTypes.Deposit + "", value: "Deposit" },
    { key: CashTransactionTypes.FundApplication + "", value: "Fund Application" },
    { key: CashTransactionTypes.Fee + "", value: "Fee" },
    { key: CashTransactionTypes.FundRedemption + "", value: "Fund Redemption" },
    { key: CashTransactionTypes.GrossCoupon + "", value: "Gross Coupon" },
    { key: CashTransactionTypes.GrossDividend + "", value: "Gross Dividend" },
    { key: CashTransactionTypes.HMRCCharge + "", value: "HMRC Charge" },
    { key: CashTransactionTypes.ProductTransfer + "", value: "Product Transfer" },
    { key: CashTransactionTypes.Rebate + "", value: "Rebate" },
    { key: CashTransactionTypes.ReturnofCapital + "", value: "Return of Capital" },
    { key: CashTransactionTypes.RightsIssue + "", value: "Right Issue" },
    { key: CashTransactionTypes.SellTrade + "", value: "Sell Trade" },
    { key: CashTransactionTypes.Tax + "", value: "Tax" },
    { key: CashTransactionTypes.TaxRelief + "", value: "Tax Relief" },
    { key: CashTransactionTypes.TermApplication + "", value: "Term Application" },
    { key: CashTransactionTypes.Withdrawal + "", value: "Withdrawal" },
    { key: CashTransactionTypes.WithholdingTax + "", value: "Withholding Tax" },
    { key: CashTransactionTypes.Other + "", value: "Other" },
];

export const PaymentSourceMap = {
    [PaymentSource.NotSpecified]: "N/A",
    [PaymentSource.Employee]: "Client",
    [PaymentSource.Employer]: "Employer",
    [PaymentSource.ThirdParty]: "Third Party",
    [PaymentSource.EmployerSalaryDeduction]: "Salary Deduction",
};

export const CashModelTypeMap = {
    [CashTransactionTypes.Unknown]: "All",
    [CashTransactionTypes.BuyTrade]: "Buy Trade",
    [CashTransactionTypes.CallTransaction]: "Call Transaction",
    [CashTransactionTypes.CapitalIn]: "Capital In",
    [CashTransactionTypes.CapitalOut]: "Capital Out",
    [CashTransactionTypes.CMTInterest]: "CMT Interest",
    [CashTransactionTypes.Compensation]: "Compensation",
    [CashTransactionTypes.CorporateAction]: "Corporate Action",
    [CashTransactionTypes.Deposit]: "Deposit",
    [CashTransactionTypes.FundApplication]: "Fund Application",
    [CashTransactionTypes.Fee]: "Fee",
    [CashTransactionTypes.FundRedemption]: "Fund Redemption",
    [CashTransactionTypes.GrossCoupon]: "Gross Coupon",
    [CashTransactionTypes.GrossDividend]: "Gross Dividend",
    [CashTransactionTypes.HMRCCharge]: "HMRC Charge",
    [CashTransactionTypes.Other]: "Other",
    [CashTransactionTypes.ProductTransfer]: "Product Transfer",
    [CashTransactionTypes.Rebate]: "Rebate",
    [CashTransactionTypes.ReturnofCapital]: "Return of Capital",
    [CashTransactionTypes.RightsIssue]: "Rights Issue",
    [CashTransactionTypes.SellTrade]: "Sell Trade",
    [CashTransactionTypes.Tax]: "Tax",
    [CashTransactionTypes.TaxRelief]: "Tax Relief",
    [CashTransactionTypes.TermApplication]: "Term Application",
    [CashTransactionTypes.Withdrawal]: "Withdrawal",
    [CashTransactionTypes.WithholdingTax]: "Withholding Tax",
};

export const Contents = {
    NoDataErrorMessage: "No corporate actions were found matching the selection criteria",
    NoAccountTransferErrorMessage: "No account transfers were found matching the selection criteria",
    NoDividendSummaryDataErrorMessage: "No dividend summary were found matching the selection criteria",
    NoInvestmentDataErrorMessage: "No investment transactions were found matching the selection criteria",
    NoCashDataErrorMessage: "No cash transactions were found matching the selection criteria",
    DividendNotes: "* For upcoming dividends, payment date and amount are subject to change until payment.",
    ImportantNotes:
        "Important note: Information on corporate actions is provided for general information purposes, as well as to allow you to communicate your instructions on Corporate Actions to your adviser, where applicable.",
    SubNotes:
        "If you are unsure of what action you should take or how any corporate action may affect your portfolio, you should obtain suitable independent advice.",

    TransactionDetailsTitle: "Scrip transaction details",
    CanNotEmpty: "Can't be empty",
    AcceptDateFormatsErrorMsg: "Incorrect date format. Enter as dd/mm/yyyy.",
    NumberValidation: "Please input valid number",
    DecimalPlaceValidation: "Value can only have 2 decimal places at max",
    CapitalGainPurpose: "Amended Sale proceeds for capital gains purposes:",
    OrderHistoryTitle: "Order history",
    TransactionHistoryTitle: "Transaction history",
    InvalidateDate: "0001-01-01T00:00:00",
};

export const getNoDataMsg = (name: string) => {
    return `No ${name} were found matching the selection criteria`;
};

export const paymentStatusMap = {
    [PaymentStatus.Authorised]: "Authorised",
    [PaymentStatus.Cancelled]: "Cancelled",
    [PaymentStatus.Completed]: "Completed",
    [PaymentStatus.Confirmed]: "Confirmed",
    [PaymentStatus.Created]: "Created",
    [PaymentStatus.Failed]: "Failed",
    [PaymentStatus.InProgress]: "In progress",
    [PaymentStatus.Placed]: "Placed",
};

export const chargeInfoText = {
    text:
        "Investment charges will only apply to certain accounts prior to 2012 (Additional Administration charges) & 'Platform charge' figures include any Product Administration charges applied to SIPP or Bond products.",
};
